<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { isInsideTelegram } from '@/telegramWebApp'

const { t } = useI18n()
const router = useRouter()
const auth = useAuthStore()

const label = computed(() => {
  if (auth.status !== 'authenticated' || auth.telegramUserId == null) return ''
  return auth.username
    ? `ID: ${auth.telegramUserId} (@${auth.username})`
    : `ID: ${auth.telegramUserId}`
})
// (a plain browser keeps its login, so it needs a way out; inside Telegram the account is the Telegram one)
const canLogOut = !isInsideTelegram()

async function logOut(): Promise<void> {
  auth.reset()
  await router.push('/auth')
}
</script>

<template>
  <footer v-if="label" class="user-footer">
    {{ label }}
    <template v-if="canLogOut">
      ·
      <button type="button" class="logout" @click="logOut">{{ t('auth.logout') }}</button>
    </template>
  </footer>
</template>

<style scoped>
.user-footer {
  padding: 0.5rem 1rem;
  text-align: center;
  font-size: 0.75rem;
  color: var(--tg-hint-color);
  border-top: 1px solid var(--tg-secondary-bg-color);
}

.logout {
  border: 0;
  background: none;
  padding: 0.5rem 0.25rem;
  font: inherit;
  color: var(--tg-link-color, inherit);
  text-decoration: underline;
  cursor: pointer;
}
</style>
